import React, { useState, useEffect } from 'react';
//import '../css/blog.css';
import { GetRecentBlogPost } from '../services/apiservice';
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';

const RecentPostList = () => {
  const [recentPost, setRecentPost] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleBlogClick = (paramlink, e) => {
    e.preventDefault();
    navigate(`/blog/${paramlink}`);
  };

  const fillRecentPost = async () => {
    try {
      const recentPostList = await GetRecentBlogPost();
      const jsonPostList = JSON.parse(recentPostList);
      setRecentPost(jsonPostList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching the data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fillRecentPost();
  }, []);

  return (
    <>
    <h3 class="title">Recent Posts</h3>

                                <ul>
                                  {
        loading ? <Loader /> :
          recentPost?.map((item) => (
            <li>
                                        <a href={"/blog/" + item.paramlink} onClick={handleBlogClick}>
                                            <img src={item.mediapath} alt={item.title} />
                                            <h3>{item.title}</h3>
                                        </a>
                                    </li>

            // <div className="recent-post">
            //   <a href={"/blog/" + item.paramlink} className='no-underline' onClick={handleBlogClick}>
            //     <img src={item.mediapath} alt="" />
            //   </a>
            //   <div>
            //     <div className="recent-post-title"><a href={"/blog/" + item.paramlink} className='no-underline' onClick={handleBlogClick}>{item.title}</a></div>
            //     <div className="recent-post-date"><FontAwesomeIcon icon={faCalendarAlt} /> {item.posteddate}</div>
            //   </div>
            // </div>
          ))
      }

                                    

                                    {/* <li>
                                        <a href="blog-details-right-sidebar.html">
                                            <img src="assets/img/blog/blog-8.jpg" alt="Image" />
                                            <h3>Sweet 16: Julian Strawther’s near-halfcourt shot sends Gonzaga into the Elite Eight.</h3>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="blog-details-right-sidebar.html">
                                            <img src="assets/img/blog/blog-7.jpg" alt="Image" />
                                            <h3>French home of Edward VIII and Wallis Simpson to become a museum.</h3>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="blog-details-right-sidebar.html">
                                            <img src="assets/img/blog/blog-6.jpg" alt="Image" />
                                            <h3>This woman left her AirPods on a plane. She tracked them to an airport worker’s home.</h3>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="blog-details-right-sidebar.html">
                                            <img src="assets/img/blog/blog-5.jpg" alt="Image" />
                                            <h3>Torture, forced abortions and insects for food.</h3>
                                        </a>
                                    </li> */}
                                </ul>
</>
    // <div className="widget">
    //   <h4 className='widget-title-bar'>Recent Post</h4>
    //   {
    //     loading ? <Loader /> :
    //       recentPost?.map((item) => (
    //         <div className="recent-post">
    //           <a href={"/blog/" + item.paramlink} className='no-underline' onClick={handleBlogClick}>
    //             <img src={item.mediapath} alt="" />
    //           </a>
    //           <div>
    //             <div className="recent-post-title"><a href={"/blog/" + item.paramlink} className='no-underline' onClick={handleBlogClick}>{item.title}</a></div>
    //             <div className="recent-post-date"><FontAwesomeIcon icon={faCalendarAlt} /> {item.posteddate}</div>
    //           </div>
    //         </div>
    //       ))
    //   }
    // </div>
  );
};

export default RecentPostList;